import { EMarkAllAsReadNotificationActionTypes, TMarkAllAsReadNotificationFailed } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const markAllAsReadFailed: () => TMarkAllAsReadNotificationFailed =
  actionGenerator<EMarkAllAsReadNotificationActionTypes.Failed>(EMarkAllAsReadNotificationActionTypes.Failed);
